<template>
<el-container class="is-vertical" style="height: 100%; width: 100%; position: fixed;">
  <top-header>
  </top-header>
  <el-container>

    <left-menu/>

    <el-main v-loading="isLoading">
      <el-form r:model="form" label-width="80px">
        <el-form-item label="帳號">
          <el-input :value="$store.state.admin.Username" disabled></el-input>
        </el-form-item>
        <el-form-item label="姓名">
          <el-input v-model="form.Name"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button style="margin-left: -80px;" @click="submit" type="primary">修改名稱</el-button>
        </el-form-item>
      </el-form>

      <a @click="isShowPasswordEditor = true">修改密碼?</a>

      <password-modal :isShow="isShowPasswordEditor" @close="isShowPasswordEditor = false"/>

    </el-main>
  </el-container>
</el-container>
</template>

<script>
import LeftMenu from '@/components/LeftMenu.vue'
import TopHeader from '@/components/TopHeader.vue'
import PasswordModal from '@/modals/PasswordModal.vue'

export default {
  components: {
    LeftMenu, TopHeader, PasswordModal
  },
  data () {
    return {
      form: {
        Name: ''
      },
      isLoading: false,
      isShowPasswordEditor: false
    }
  },
  methods: {
    submit () {
      if (!this.validateInput()) { return }
      this.$services.administrator.updateMe(this, this.form).then((res) => {
        let ok = res && res.data && res.data.status === 'ok'
        if (ok) this.onOK()
      })
    },
    onOK () {
      this.$message({
        message: `修改成功`,
        type: 'success'
      })
      this.$store.state.admin.Profile.Name = this.form.Name
    },
    validateInput () {
      var errMsg = null
      if (!this.form.Name) {
        errMsg = '請輸入姓名'
      }
      // 時間..
      if (errMsg != null) {
        this.$alert(errMsg, '錯誤', {
          confirmButtonText: '確認',
          type: 'error'
        })
      }
      return errMsg === null
    }
  },
  created () {
    this.form.Name = this.$store.state.admin.Profile.Name
  }
}
</script>

<style>
a {
  color: gray;
  text-decoration: underline;
  cursor: pointer;
}
</style>
